import { Button, Layout, Modal, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { deleteRequest, get, post } from '../../Common/api'
import { PlusOutlined } from '@ant-design/icons'
import IntervenerForm from '../IntervenerPage/IntervenerForm'
import { useForm } from 'antd/es/form/Form'
import { t } from 'i18next'
import IntervenerFilter from './IntervenerFilter'
import { Color } from '../../Common/Color'
import IntervenersTab from './IntervenersTab'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

export default function IntervenersPage () {
  const [activeInterveners, setActiveInterveners] = useState([])
  const [deletedInterveners, setDeletedInterveners] = useState([])
  const [boxes, setBoxes] = useState([])
  const [loading, setLoading] = useState(false)
  const [filter, setFilter] = useState({ name: '', box_id: '', job: 'all' })
  const [modalVisible, setModalVisible] = useState(false)
  const [form] = useForm()
  const screens = useBreakpoint()

  useEffect(() => {
    getInterveners()
    getBoxes()
  }, [])

  const formatIntervener = (intervener) => (
    { ...intervener, phones: (intervener.phones.map(phone => ({ ...phone, value: `+${phone.value}` }))) }
  )

  const getInterveners = async () => {
    setLoading(true)
    await get('admin/interveners', {}, (res) => {
      setActiveInterveners([...res.active.map(i => formatIntervener(i))])
      setDeletedInterveners([...res.deleted.map(i => formatIntervener(i))])
      setLoading(false)
    }, () => {
      setLoading(false)
    })
  }

  const getBoxes = async () => {
    setLoading(true)
    await get('admin/boxes', {}, (res) => {
      setLoading(false)
      setBoxes(res.boxes)
    }, () => {
      setLoading(false)
    })
  }

  const onChangeFilter = (filter) => {
    setFilter(filter)
  }

  const openFormModal = (intervener) => {
    form.resetFields()
    if (intervener) {
      form.setFieldsValue(intervener)
    }
    setModalVisible(true)
  }

  const addRequest = async (values) => {
    setLoading(true)
    await post('admin/interveners', values, (res) => {
      setActiveInterveners([...activeInterveners, formatIntervener(res)])
      setLoading(false)
      setModalVisible(false)
    }, () => {
      setLoading(false)
    })
  }

  const deleteIntervener = async (intervener) => {
    await deleteRequest(`admin/interveners/${intervener.id}`, {}, (res) => {
      const intervener = activeInterveners.find(i => i.id === res.id)
      setActiveInterveners(activeInterveners.filter(i => i.id !== res.id))
      setDeletedInterveners([...deletedInterveners, intervener])
      setLoading(false)
    }, () => {
      setLoading(false)
    })
  }

  const deleteIntervenerModal = async (intervener) => {
    Modal.confirm({
      title: `${t('Admin.IntervenersPage.deletePopupTitle')} "${intervener.last_name} ${intervener.first_name}"`,
      width: '600px',
      okText: t('actions.confirm'),
      onOk: () => deleteIntervener(intervener)
    })
  }

  const filteredInterveners = (interveners) => {
    return interveners.filter((intervener) => {
      return intervener.name.toLowerCase().includes(filter.name.toLowerCase()) &&
        (!filter.box_id || intervener.boxes.map(box => box.id).includes(filter.box_id)) &&
        (filter.job === 'all' || intervener.job.includes(filter.job))
    })
  }

  return (
    <Layout style={{ marginTop: '1em' }} >
      <Layout style={{ padding: '1em 0', color: Color.dark_blue, fontSize: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: '20px' }}><b>{activeInterveners.length + deletedInterveners.length}</b> {t('Admin.BoxesPage.title')}</div>
          { !screens.xs && <IntervenerFilter boxes={boxes} filter={filter} onChangeFilter={onChangeFilter} /> }
          <Button onClick={() => openFormModal()} type="primary" style={{ marginLeft: 'auto' }} shape="circle" icon={<PlusOutlined />} />
        </div>
      </Layout>
      <Spin spinning={loading}>
        <IntervenersTab
          activeInterveners={filteredInterveners(activeInterveners)}
          deletedInterveners={filteredInterveners(deletedInterveners)}
          deleteModal={deleteIntervenerModal}
        />
        {modalVisible && <Modal
          open={modalVisible}
          width="1000px"
          title={t('Admin.IntervenersPage.addIntervenerTitle')}
          confirmLoading={loading}
          footer={null}
        >
          <Spin spinning={loading}>
            <IntervenerForm form={form} action="add" addRequest={addRequest} closeModal={() => setModalVisible(false)} />
          </Spin>
        </Modal>}
      </Spin>
    </Layout >
  )
}
